'use client';

import { Box, freddyTheme, Loader } from '@coolblue-development/freddy';
import { FilterPageContext } from '@features/filter/context';
import { type ReactNode, useContext } from 'react';

import getPendingWrapperStyles from './PendingWrapper.styles';

export default function PendingWrapper({
  children,
  showLoader
}: {
  children: ReactNode;
  showLoader?: boolean;
}) {
  const { isPending } = useContext(FilterPageContext);

  const { wrapperStyles, childrenWrapperStyles, loaderStyles } = getPendingWrapperStyles({
    isPending,
    showLoader,
    theme: freddyTheme
  });

  return (
    <Box sx={wrapperStyles}>
      {showLoader && isPending && (
        <Box sx={loaderStyles}>
          <Loader />
        </Box>
      )}

      <Box sx={childrenWrapperStyles}>{children}</Box>
    </Box>
  );
}
